import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_10_invoice_receivables: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Receipt vouchers",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "invoice_receivables",
        TableName: "service_invoice_receivables",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        fieldVisibilityRules: [
          { when: { field: "drp_billmode", label: "Cheque" }, showFields: ["txt_bank_name", "txt_cheque_no", "txt_cheque_date"] },
        ],
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Receipt voucher details",
            BindValue: "con_receipt_voucher_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_customer",
                label: "Customer name",
                placeholder: "Select customer",
                required: true,
                lookupName: "customers_with_due_from_transaction",
                options: [],
                Json_Attribute: "customer_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Customer name is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_reciept_no",
                label: "Receipt No.",
                placeholder: "Will be auto generated...",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "reciept_no",
                AutoPopulate: true,
                AutoPopulate_format: "REC_[******]",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_date",
                label: "Date",
                placeholder: "",
                DefaultToday: true,
                required: true,
                Json_Attribute: "date",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_billmode",
                label: "Bill mode",
                placeholder: "Select bill mode",
                required: true,
                lookupName: "billmodes_from_ledger",
                options: [],
                Json_Attribute: "bill_mode",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Bill mode is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_bank",
                label: "Debit account",
                placeholder: "Select account",
                required: false,
                lookupName: "bank_details",
                options: [],
                Json_Attribute: "details",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_bank_name",
                label: "Bank name",
                placeholder: "",
                required: true,
                inputType: InputType.TEXT,
                Json_Attribute: "bank_name",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_cheque_no",
                label: "Cheque number",
                placeholder: "",
                required: true,
                inputType: InputType.TEXT,
                Json_Attribute: "cheque_no",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_cheque_date",
                label: "Cheque date",
                placeholder: "",
                required: true,
                Json_Attribute: "cheque_date",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due",
                label: "Ledger amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                disabled: true,
                Json_Attribute: "",
                BindParent: {
                  drp_customer: "amount",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_Ref_no",
                label: "Ref No.",
                placeholder: "Ref No.",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "ref_no",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_reference_date",
                label: "Reference date",
                placeholder: "",
                DefaultToday: true,
                required: true,
                Json_Attribute: "reference_date",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Reference date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_AREA,
                name: "txt_remarks",
                label: "Details",
                placeholder: "",
                required: true,
                rows: 3,
                Json_Attribute: "remarks",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Details is required",
                  },
                ],
              },
              
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "invoice_recivebles",
            label: "Invoice details",
            tableName: "invoice_recivebles_split",
            lookupName: "customer_invoice_details",
            parentField: "drp_customer",
            BindValue: "invoice_recivebles_split",
            viewAction: {
              // Side drawer report: POST /pabreport/report?name=invoice_info → HTML in drawer
              drawerReportName: "Invoice_info",
              idField: "id",
            },
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_invoice_no",
                label: "Invoice No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "invoice_no",
                disabled: true,
                BindValue: "txt_invoice_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_total_amount",
                label: "Total amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "total_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_total_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_paid_amount",
                label: "Amount paid",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount_paid",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_paid_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_discount_amount",
                label: "Discount amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "discounted_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_discount_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due_amount",
                label: "Due amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "due_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_due_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount",
                defaultValue: "0",
                BindValue: "txt_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_discount",
                label: "Discount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "discount",
                defaultValue: "0",
                BindValue: "txt_discount",
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_5",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_9",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_discount",
                Json_Attribute: "net_discount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_discount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
